




























































import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import { Component } from 'vue-property-decorator';
import { PageConfigurations, IssueDetails } from './types/index';
import { MAP_ERROR_MESSAGE, MAP_PARAMETERS } from  './constants/index';
import UUIFComponents from '@/shared/uuifComponent';
import { currentUserKey } from '../../shared/msw-constants';
import { SwActionBar, SwActionBarItem } from '@libs-uuif/shared/sw-action-bar';
import { SwForm, SwFormRow, SwFormRowError } from '@sonicwall/unified-ui-framework/src/shared/sw-form';
import  MswAppTitle  from '@/shared/msw-app-title/msw-app-title.vue';
import { SwTextfield } from '@libs-uuif/shared/sw-textfield';
import { PageTitleConfig } from '../../shared/msw-app-title/type';

const cssPrefix = 'issueList';
@Component({
  components: {
    ...UUIFComponents,
    SwActionBar,
    SwActionBarItem,
    SwForm,
    SwFormRow,
    SwFormRowError,
    MswAppTitle,
    SwTextfield,
  },
})
export default class MswIssueList extends SwExtendedVue {
  cssPrefix = cssPrefix;
  pageConfig : PageConfigurations = {};
  enteredValue: string = '';
  isSubmitted: boolean = false;
  pageLoaded : boolean = true;

  details: IssueDetails[] = [];
  showDetails: boolean = false;

  messageText: string = '';
  messageColor: string = '';

  created() {
    this.fetchIssueListHeaders();
  }

  fetchIssueListHeaders() {
    this.pageLoaded = false;
    this.$store.dispatch('MswIssueListModule/fetchIssueListHeaders')
      .then((response: any) => {
        if (response.msgCode === 'MSWAPP:GETISSUEDETAILSSUCCESS') {
          const issueHeader = response?.content?.issueHeaders[0] || {};
          this.pageConfigurations = { ...issueHeader };
          this.pageLoaded = true;
        }
      })
      .then(() => {
        this.$nextTick(() => {
          this.makeTextFieldFocus();
        });
      })
      .catch((errorResponse: any) => {
        console.table(errorResponse);
      })
      .finally(() => {
        this.$store.commit('stopLoading');
      });
  }

  set pageConfigurations(issueHeader: PageConfigurations) {
    this.pageConfig.clearButtonText = issueHeader?.clearButtonText || '';
    this.pageConfig.hyperLinkText = issueHeader?.hyperLinkText || '';
    this.pageConfig.pageDescription = issueHeader?.pageDescription || '';
    this.pageConfig.pageHeader = issueHeader?.pageHeader || '';
    this.pageConfig.pageSubHeader = issueHeader?.pageSubHeader || '';
    this.pageConfig.submitText = issueHeader?.submitText || '';
    this.pageConfig.textBoxLabel = issueHeader?.textBoxLabel || '';
    this.pageConfig.textboxWaterMark = issueHeader?.textboxWaterMark || '';
    this.pageConfig.showDetail = issueHeader?.showDetail || '';
  }

  get pageConfigurations(): PageConfigurations {
    return this.pageConfig;
  }

  set issueDetails(value : IssueDetails[]) {
    this.details = [...value];
  }

  get issueDetails(): IssueDetails[] {
    return this.details;
  }

  get getHeaderConfig(): PageTitleConfig {
    return {
      pageTitle: this.pageConfigurations.pageHeader,
      pageParentName: this.pageConfigurations.pageHeader,
    };
  }

  getError(type: string) {
    return [`${MAP_ERROR_MESSAGE(type)}`];
  }

  onClear() {
    this.enteredValue = '';
    this.isSubmitted = false;
  }

  onSubmit(type: string) {
    this.isSubmitted = true;
    this.showDetails = false;
    this.messageText = '';
    if (this.enteredValue) {
      const userObj = localStorage.getItem(currentUserKey);
      let userId = '';
      if (userObj) {
        userId = JSON.parse(localStorage.getItem(currentUserKey) as any).userId || '';
      }
      const request = {
        [MAP_PARAMETERS(type)] : this.enteredValue,
        userName: userId,
      };
      this.$store.dispatch('MswIssueListModule/getnewIssueListDetails', request)
        .then((response: any) => {
          if (response.msgCode === 'MSWAPP:GETISSUEDETAILSSUCCESS') {
            this.issueDetails = response?.content?.issueDetails || [];
            this.showDetails = true;
            this.messageText = response?.msgDesc || '';
            this.messageColor = response?.messagecolorcode || '';
          }
        })
        .catch((errorResponse: any) => {
          console.table(errorResponse);
        })
        .finally(() => {
          this.$store.commit('stopLoading');
        });
    }
  }

  makeTextFieldFocus() {
    (this.$refs['inputField'] as SwTextfield) &&
    (this.$refs['inputField'] as SwTextfield).focus();
  }
}
